module.exports = __webpack_public_path__ + "static/media/4.2bbd7709.png";